import { Typography, MediaImageStandard } from 'components/Contentful'
import { Grid } from '@achieve/ascend'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'

const ClickableWrapper = ({ children, href }) => {
  return (
    <AchieveLink className='no-underline hover:text-[#1d252f]' href={href}>
      {children}
    </AchieveLink>
  )
}

export function CardEmployeeStory({ content }) {
  const { image, title, text, link, eyebrow } = content
  return (
    <Grid className='max-w-[90%] flex items-start flex-col'>
      <ClickableWrapper href={link.linkHref}>
        <Grid className='w-[335px] h-[252px] overflow-hidden rounded-xl lg:w-[390px] lg:h-[293px]'>
          <MediaImageStandard
            content={image}
            className="relative"
            layout="fill"
          />
        </Grid>
      </ClickableWrapper>
      <Grid className='flex items-start flex-col'>
        <Typography
          content={eyebrow}
          variant="bodySm"
          component="h3"
          className="mt-6 mb-1"
          fontWeight="bold"
          data-testid={`card-eyebrow`}
        />
        <ClickableWrapper href={link.linkHref}>
          <Typography
            content={title}
            variant={'headingMd'}
            component="h3"
            className="text-[#1d252f] no-underline text-left my-4"
            fontWeight="medium"
            data-testid={`card-title`}
          />
        </ClickableWrapper>
        <Typography
          content={text}
          variant="bodySm"
          className="mb-4"
          data-testid={`card-text`}
        />

        <div>
          <AchieveLink href={link.linkHref} underline="hover">
            <Typography content={link.linkText} fontWeight="bold" variant="bodyLg" />
          </AchieveLink>
        </div>
      </Grid>
    </Grid>
  )
}
